import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment, getOpenAIKey } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { OpenAiResponse, Run } from '../models/gpt-response.model';
import { ChatThreadDTO } from 'app/core/community/models/chatThread.model';


@Injectable({
  providedIn: 'root',
})
export class ChatService {
  constructor(private http: HttpClient) {}


	public API_LIST_BY_ELEMENT_URL = environment.ipserver + 'o2c-backend/private/chatThread/listByUser';
	public API_REGISTER_URL = environment.ipserver + 'o2c-backend/private/chatThread/register';
  // Define a method to send a message and receive a response from ChatGPT
//   async chat(message: string, threadId: string): Promise<OpenAiResponse> {



// 			await this.createMessage(threadId,message);
// 			const messages = await this.runAssistant(threadId);
// 			let response : OpenAiResponse = new OpenAiResponse();
// 			response.messages = messages;
// 			response.threadId = threadId;

// 			return response;




//   }

    createThread() : Observable<any> {

	/*const headers = new HttpHeaders({
		'Content-Type': 'application/json',
		'Authorization': `Bearer ${environment.openAIKey}`,
		'OpenAI-Beta': 'assistants=v2'

	  });*/
	  const headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getOpenAIKey(), 'OpenAI-Beta': 'assistants=v2' };


	 return  this.http
      .post<unknown>('https://api.openai.com/v1/threads', '', {
		headers
      })
      ;


 };

  createMessage (threadId: string, content: string)
	{
		const headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getOpenAIKey(), 'OpenAI-Beta': 'assistants=v2' };

		  const body = {
			role: 'user',
			content: content
		  };
		  let url : string = 'https://api.openai.com/v1/threads/'+threadId +'/messages';
		 return this.http
      .post<unknown>(url,body,  {
		headers
      });

	};

	 runAssistant(threadId: string)
		{
			const headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getOpenAIKey(), 'OpenAI-Beta': 'assistants=v2' };


		  const body = {
			assistant_id: environment.openAIAssistantId,

		  };
		  let url : string = 'https://api.openai.com/v1/threads/'+threadId +'/runs';
		  return  this.http
		  .post<unknown>(url, body, {
			headers
		  });
		}

		runRetrieve(threadId: string, runId : string)
		{
			const headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getOpenAIKey(), 'OpenAI-Beta': 'assistants=v2' };
			let url : string = 'https://api.openai.com/v1/threads/'+threadId+ '/runs/' +runId;
		  return this.http.get<unknown>(url,  {
			headers
			  })
		}

		listMessages(threadId: string)
		{
			const headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getOpenAIKey(), 'OpenAI-Beta': 'assistants=v2' };
			let url : string = 'https://api.openai.com/v1/threads/'+threadId+'/messages';
		  return this.http.get<unknown>(url,  {
			headers
			  });
		}

		public getThreads(userName: string): Observable<ChatThreadDTO[]> {
			let paramsForReq;
			if(userName) {
				paramsForReq = new HttpParams()
							.set('userName', userName);
			}
					return this.http.get<ChatThreadDTO[]>(this.API_LIST_BY_ELEMENT_URL, { params: paramsForReq });
			}

			public postThread(chatThread: ChatThreadDTO): Observable<boolean> {
        const type = 'text' as 'json';
        return this.http.post<boolean>(this.API_REGISTER_URL, chatThread, { responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                })
            );
		}
		
		getFileContent(fileId: string)
		{
			const headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getOpenAIKey(), 'OpenAI-Beta': 'assistants=v2' };
			let url : string = 'https://api.openai.com/v1/files/'+fileId+ '/content';
		  return this.http.get<unknown>(url,  {
			headers
			  })
		}
		getFile(fileId: string)
		{
			const headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getOpenAIKey(), 'OpenAI-Beta': 'assistants=v2' };
			let url : string = 'https://api.openai.com/v1/files/'+fileId;
		  return this.http.get<unknown>(url,  {
			headers
			  })
		}
	
}
